import Vue from 'vue';

const toastModule = {
  namespaced: true,

  actions: {
    success(_, message) {
      Vue.toasted.global.pixSuccess(message);
    },

    error(_, message) {
      Vue.toasted.global.pixError(message);
    },

    info(_, message) {
      Vue.toasted.global.pixInfo(message);
    },

    warning(_, message) {
      Vue.toasted.global.pixWarning(message);
    },
  },
};

export default toastModule;
